var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.703,
    height: 17.838,
    viewBox: "0 0 12.703 17.838"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10819",
    "data-name": "Group 10819",
    transform: "translate(-895.65 -373.644)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3849",
    "data-name": "Rectangle 3849",
    width: 11.003,
    height: 16.138,
    transform: "translate(896.5 374.494)",
    fill: "none",
    stroke: "#74757d",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_546",
    "data-name": "Ellipse 546",
    transform: "translate(901 387)",
    fill: "none",
    stroke: "#74757d",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x2: 11,
    transform: "translate(896.5 385.5)",
    fill: "none",
    stroke: "#74757d",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }))));
};
export default SvgMobile;